import { useAtomValue } from 'jotai';
import { $CurrentAvailableArticleOrNull } from '@article/shared/atoms/current-article';
import { loadable } from 'jotai/utils';

export const useArticleKeywords = (): string[] => {
  const loadableArticle = useAtomValue(loadable($CurrentAvailableArticleOrNull));

  if (loadableArticle.state !== 'hasData' || !loadableArticle.data) {
    return [];
  }

  const article = loadableArticle.data;

  const result: string[] = [];
  // const { relatedQueryInfos } = article;

  const articleTitle = article.title;
  if (articleTitle) {
    result.push(articleTitle);
  }

  result.push(article.author.nickName);
  // result.push(...relatedQueryInfos.map((info) => info.word));
  result.push('Lemon8');

  return result;
};
